'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang='en'>
      <body>
        <div className='flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center'>
          <h2 className='text-2xl font-semibold tracking-tight'>
            Something went wrong
          </h2>
          <p className='max-w-md text-sm' style={{ color: '#6b7280' }}>
            A critical error occurred. Please try again or contact support if
            the problem persists.
          </p>
          {error.digest && (
            <p className='font-mono text-xs' style={{ color: '#9ca3af' }}>
              Error ID: {error.digest}
            </p>
          )}
          <button
            onClick={reset}
            style={{
              backgroundColor: '#2563eb',
              color: '#fff',
              borderRadius: '0.375rem',
              padding: '0.5rem 1rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              cursor: 'pointer',
              border: 'none',
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
